import { stripNewlinesFromFragment } from '../../serializers/pasteNormalize';
import { generateCellId } from '../../components/TableElements/tableElementsUtils';
import { IMPORT_MODE, type ImportMode } from './constants';

/** Stamp td/th ids before insert so normalize doesn't walk a CAM-sized table one cell at a time. */
export function stampMissingCellIds(nodes: any[]): any[] {
    const walk = (node: any): any => {
        if (!node || typeof node !== 'object') return node;
        const children = Array.isArray(node.children) ? node.children.map(walk) : node.children;
        if ((node.type === 'td' || node.type === 'th') && !node.id) {
            return { ...node, id: generateCellId(), children };
        }
        return children !== node.children ? { ...node, children } : node;
    };
    return Array.isArray(nodes) ? nodes.map(walk) : nodes;
}

/**
 * Insert an imported fragment. `withoutSaving` keeps Slate history from cloning
 * every table op (append-into-a-CAM was spending seconds snapshotting undos).
 * Ids are stamped first so the post-insert normalize is a no-op for cell ids.
 */
export function applyImportedFragment(editor: any, fragment: any[], mode: ImportMode): void {
    const nodes = stampMissingCellIds(stripNewlinesFromFragment(fragment));
    const run = () => {
        editor?.tf?.withoutNormalizing?.(() => {
            if (mode === IMPORT_MODE.REPLACE) {
                const previous = (editor.children ?? []).slice();
                try {
                    for (let i = (editor.children?.length ?? 0) - 1; i >= 0; i -= 1) {
                        editor.tf.removeNodes({ at: [i] });
                    }
                    editor.tf.insertNodes(nodes, { at: [0] });
                } catch (err) {
                    for (let i = (editor.children?.length ?? 0) - 1; i >= 0; i -= 1) {
                        editor.tf.removeNodes({ at: [i] });
                    }
                    if (previous.length) editor.tf.insertNodes(previous, { at: [0] });
                    throw err;
                }
            } else {
                editor.tf.insertNodes(nodes, { at: [editor.children.length] });
            }
        });
        editor?.tf?.deselect?.();
    };
    if (typeof editor?.tf?.withoutSaving === 'function') editor.tf.withoutSaving(run);
    else run();
}
